import axios from "axios";
import { BaseApiUrl } from "./base";
import { expandMediaListItems } from "../utils/mediaUrl";

const base = BaseApiUrl;

/** 从部门树节点向上解析学校 Id（配置页 GetConfig 用） */
export function resolveSchoolIdFromTreeNode(node, fallbackId) {
  const schoolLike = ["school", "campus", "affiliateschool"];
  if (node && node.data) {
    const selfType = String(node.data.DeptOrgType != null ? node.data.DeptOrgType : node.data.deptOrgType || "").toLowerCase();
    if (schoolLike.includes(selfType)) {
      return Number(node.data.value);
    }
  }
  let n = node && node.parent;
  while (n && n.data) {
    const t = String((n.data.DeptOrgType != null ? n.data.DeptOrgType : n.data.deptOrgType) || "").toLowerCase();
    if (schoolLike.includes(t)) {
      return Number(n.data.value);
    }
    n = n.parent;
  }
  return fallbackId ? Number(fallbackId) : 0;
}

/** 是否行政班节点 */
export function isClassDeptNode(node) {
  if (!node || !node.data) return false;
  const t = String(node.data.DeptOrgType != null ? node.data.DeptOrgType : node.data.deptOrgType || "").toLowerCase();
  return t === "class";
}

/** 从 el-tree 节点收集下级所有行政班（含自身若为 class） */
export function collectClassOptionsFromTreeNode(node) {
  const list = [];
  const seen = new Set();
  const walk = (n) => {
    if (!n) return;
    const data = n.data || n;
    const t = String(data.DeptOrgType != null ? data.DeptOrgType : data.deptOrgType || "").toLowerCase();
    const id = data.value != null ? data.value : data.Id;
    if (t === "class" && id != null && !seen.has(id)) {
      seen.add(id);
      list.push({ id: Number(id), name: data.label || data.Name || "" });
    }
    const childNodes = n.childNodes;
    if (Array.isArray(childNodes) && childNodes.length) {
      childNodes.forEach(walk);
      return;
    }
    const children = data.children;
    if (Array.isArray(children)) {
      children.forEach(walk);
    }
  };
  walk(node);
  list.sort((a, b) => (a.name || "").localeCompare(b.name || "", "zh-CN"));
  return list;
}

/** 切换左侧机构树时清空列表 */
export function clearClassCircleListTable(vm) {
  if (Object.prototype.hasOwnProperty.call(vm, "rows")) vm.rows = [];
  if (Object.prototype.hasOwnProperty.call(vm, "users")) vm.users = [];
  if (Object.prototype.hasOwnProperty.call(vm, "total")) vm.total = 0;
  if (Object.prototype.hasOwnProperty.call(vm, "page")) vm.page = 1;
}

export function onClassCircleDeptChange(vm, departmentId) {
  vm.DepartmentId = departmentId;
  clearClassCircleListTable(vm);
}

/** 筛选区权限按钮样式（删除 danger、导出 success 等） */
export function resolveClassCircleActionButton(item) {
  const func = item && (item.Func || item.func);
  const map = {
    handleDel: { type: "danger", plain: true, icon: "el-icon-delete" },
    exportExcel: { type: "success", plain: true, icon: "el-icon-download" },
    handleAdd: { type: "primary", plain: true, icon: "el-icon-plus" },
    handleEdit: { type: "primary", plain: true, icon: "el-icon-edit" }
  };
  return map[func] || { plain: true };
}

/** Toolbar 按钮分发（同步筛选条件并调用 Func 对应方法） */
export function invokeToolbarMethod(vm, item) {
  if (item && typeof item.search === "object") {
    vm.filters = item.search;
  }
  const funcName = item && (item.Func || item.func);
  if (!funcName) return false;
  if (typeof vm[funcName] === "function") {
    vm[funcName](item);
    return true;
  }
  return false;
}

/** 工具栏编辑：须选中恰好一行 */
export function pickSingleRow(vm, tip) {
  const rows = vm.multipleSelection || [];
  if (rows.length !== 1) {
    vm.$message.error(tip || "请选择一行数据");
    return null;
  }
  return rows[0];
}

/** 工具栏删除：须至少选中一行 */
export function pickMultiRows(vm, tip) {
  const rows = vm.multipleSelection || [];
  if (!rows.length) {
    vm.$message.error(tip || "请选择要操作的数据");
    return null;
  }
  return rows;
}

export const publisherTypeOptions = [
  { label: "全部", value: null },
  { label: "教师", value: 1 },
  { label: "家长", value: 2 }
];

export const auditStatusOptions = [
  { label: "全部", value: null },
  { label: "待审", value: 0 },
  { label: "通过", value: 1 },
  { label: "拒绝", value: 2 }
];

export const deleteStatusOptions = [
  { label: "全部", value: null },
  { label: "正常", value: false },
  { label: "已删", value: true }
];

export const contentTypeText = (type) => {
  const map = { 1: "文字", 2: "图片", 3: "视频", 4: "混合" };
  return map[type] || String(type);
};

export const auditStatusText = (status) => {
  const map = { 0: "待审", 1: "通过", 2: "拒绝" };
  return map[status] != null ? map[status] : String(status);
};

export const targetTypeText = (type) => (type === 2 ? "家长账号" : "学生");

export function countMediaItems(mediaJson) {
  if (!mediaJson) return 0;
  try {
    const arr = JSON.parse(mediaJson);
    return Array.isArray(arr) ? arr.length : 0;
  } catch (e) {
    return 0;
  }
}

export function formatDateTime(val) {
  if (!val) return "";
  return String(val).replace("T", " ").substring(0, 19);
}

export function truncateText(text, maxLen) {
  if (!text) return "";
  const s = String(text);
  return s.length <= maxLen ? s : s.substring(0, maxLen) + "…";
}

/**
 * 帖子引用来源文案（后台列表「来源」列；refSourceType=1 为班牌阵地引用）
 */
export function refSourceLabel(row) {
  if (!row) return "—";
  const type = row.refSourceType != null ? row.refSourceType : row.RefSourceType;
  if (type !== 1) return "—";
  const cat = row.refCategory || row.RefCategory || "";
  const id = row.refSourceId != null ? row.refSourceId : row.RefSourceId;
  if (cat && id != null) return `${cat}#${id}`;
  if (cat) return cat;
  return id != null ? String(id) : "班牌阵地";
}

/** 评论者/互动者类型文案 */
export function commenterTypeLabel(type) {
  return type === 1 ? "教师" : "家长";
}

/** 互动者展示：类型 + 姓名 */
export function actorLabel(row) {
  if (!row) return "";
  const type = row.actorType != null ? row.actorType : row.ActorType;
  const name = row.actorName || row.ActorName || "";
  return commenterTypeLabel(type) + (name ? "：" + name : "");
}

/** 解析媒体 JSON */
export function parseMediaList(mediaJson) {
  if (!mediaJson) return [];
  try {
    const arr = JSON.parse(mediaJson);
    if (!Array.isArray(arr)) return [];
    return expandMediaListItems(arr.sort((a, b) => (a.sort || 0) - (b.sort || 0)));
  } catch (e) {
    return [];
  }
}

/** 媒体项 URL */
export function mediaItemUrl(item) {
  return item ? (item.url || item.Url || "") : "";
}

/** 媒体项类型：image / video；无 type 时按扩展名推断 */
export function mediaItemType(item) {
  const declared = String((item && (item.type || item.Type)) || "").toLowerCase();
  if (declared === "image" || declared === "video") return declared;
  const url = String(mediaItemUrl(item)).toLowerCase();
  if (/\.(mp4|mov|webm|m3u8)(\?|#|$)/i.test(url)) return "video";
  if (url) return "image";
  return "";
}

export function isImageMedia(item) {
  return mediaItemType(item) === "image";
}

export function isVideoMedia(item) {
  return mediaItemType(item) === "video";
}

/** 媒体类型文案 */
export function mediaTypeLabel(item) {
  return isVideoMedia(item) ? "视频" : "图片";
}

/** 拼接媒体完整 URL */
export function resolveMediaFullUrl(baseUrl, url) {
  if (!url) return "";
  const p = String(url);
  if (p.startsWith("http")) return p;
  return String(baseUrl || "").replace(/\/$/, "") + p;
}

/** 扁平评论列表组装二级树 */
export function buildCommentTree(flatList) {
  const nodes = (flatList || []).map(c => {
    const id = c.id != null ? c.id : c.Id;
    const parentId = c.parentCommentId != null ? c.parentCommentId : c.ParentCommentId;
    return {
      raw: c,
      id,
      parentCommentId: parentId,
      commenterType: c.commenterType != null ? c.commenterType : c.CommenterType,
      commenterName: c.commenterName || c.CommenterName || "",
      content: c.content || c.Content || "",
      createTime: c.createTime || c.CreateTime,
      isDeleted: !!(c.isDeleted != null ? c.isDeleted : c.IsDeleted),
      replies: []
    };
  });
  const map = {};
  nodes.forEach(n => { map[n.id] = n; });
  const roots = [];
  nodes.forEach(n => {
    if (n.parentCommentId && map[n.parentCommentId]) {
      map[n.parentCommentId].replies.push(n);
    } else {
      roots.push(n);
    }
  });
  const byTime = (a, b) => new Date(a.createTime) - new Date(b.createTime);
  roots.sort(byTime);
  roots.forEach(r => r.replies.sort(byTime));
  return roots;
}

export const getClassCircleConfig = (schoolId) => {
  return axios.get(`${base}/api/ClassCircleAdmin/GetConfig`, { params: { schoolId } });
};

export const saveClassCircleConfig = (data) => {
  return axios.post(`${base}/api/ClassCircleAdmin/SaveConfig`, data);
};

export const getClassCirclePostPage = (data) => {
  return axios.post(`${base}/api/ClassCircleAdmin/GetPostPage`, data);
};

export const getClassCircleCommentPage = (data) => {
  return axios.post(`${base}/api/ClassCircleAdmin/GetCommentPage`, data);
};

export const getClassCircleLikePage = (data) => {
  return axios.post(`${base}/api/ClassCircleAdmin/GetLikePage`, data);
};

export const getClassCircleFavoritePage = (data) => {
  return axios.post(`${base}/api/ClassCircleAdmin/GetFavoritePage`, data);
};

export const getClassCircleRestrictionPage = (data) => {
  return axios.post(`${base}/api/ClassCircleAdmin/GetRestrictionPage`, data);
};

export const auditClassCirclePost = (data) => {
  return axios.post(`${base}/api/ClassCircleAdmin/AuditPost`, data);
};

export const deleteClassCirclePost = (postId) => {
  return axios.post(`${base}/api/ClassCircleAdmin/DeletePost`, { postId });
};

export const restoreClassCirclePost = (postId) => {
  return axios.post(`${base}/api/ClassCircleAdmin/RestorePost`, { postId });
};

export const deleteClassCircleComment = (commentId) => {
  return axios.post(`${base}/api/ClassCircleAdmin/DeleteComment`, { commentId });
};

export const setClassCircleMemberRestriction = (data) => {
  return axios.post(`${base}/api/ClassCircleAdmin/SetMemberRestriction`, data);
};

export const exportClassCirclePosts = (data) => {
  return axios.post(`${base}/api/ClassCircleAdmin/ExportPosts`, data, { responseType: "blob" });
};

export const exportClassCircleComments = (data) => {
  return axios.post(`${base}/api/ClassCircleAdmin/ExportComments`, data, { responseType: "blob" });
};

/** 下载 blob 为 Excel */
export function downloadBlobExcel(res, filePrefix) {
  const blob = new Blob([res.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filePrefix + "_" + new Date().getTime() + ".xlsx";
  link.click();
  window.URL.revokeObjectURL(url);
}
